<template>
  <b-card class="general_info">
    <div v-if="loading">
      <b-row>
        <b-col cols="12" lg="6" v-for="n in 4" :key="n">
          <b-card>
            <b-skeleton height="30px" width="30%"></b-skeleton>
            <b-skeleton v-for="n in 3" :key="n"></b-skeleton>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <template v-else>
      <b-row>
        <b-col cols="12" lg="6">
          <info-card
            :label="`عدد أعضاء مجلس ${councilType}`"
            :value="general_info.board_members_count"
          />
        </b-col>
        <b-col cols="12" lg="6">
          <info-card
            :label="`نوع مجلس ${councilType}`"
            :value="general_info.boardType ? general_info.boardType.name : ''"
          />
        </b-col>

        <b-col cols="12" lg="6">
          <info-card
            :label="`تاريخ انتخاب / تعيين مجلس ${councilType}`"
            :value="general_info.board_election_date"
          />
        </b-col>
        <b-col cols="12" lg="6">
          <info-card
            :label="`مدة ولاية مجلس ${councilType}`"
            :value="general_info.term_of_office"
          />
        </b-col>
        <b-col cols="12" lg="6">
          <info-card
            v-if="general_info.members_type"
            label="عدد أعضاء الهيئة العامة الكلي"
            :value="general_info.public_authority_total_count"
          />
        </b-col>
        <b-col cols="12" lg="6">
          <info-card
            v-if="general_info.members_type"
            label="عدد أعضاء الهيئة العامة القادرين على التصويت"
            :value="general_info.authorised_to_vote_count"
          />
        </b-col>
        <b-col cols="12" lg="6">
          <info-card
            v-if="general_info.members_type"
            label="تاريخ آخر انعقاد للهيئة العامة"
            :value="general_info.public_authority_last_meeting"
          />
        </b-col>
      </b-row>

      <div class="d-flex justify-content-end mt-2">
        <b-button @click="openEditModal" variant="primary">
          <feather-icon icon="EditIcon" size="16" class="mr-50" />
          تعديل
        </b-button>
      </div>
    </template>
    <form-modal
      :formSchema="formSchema"
      v-model="isModalVisible"
      ref="editModal"
      :loading="editing"
      title="تعديل المعلومات التنظيمية العامة"
      static
      @confirm="editConfirmed"
    />
  </b-card>
</template>
<script>
import { BCard, BSkeleton, BButton, BRow, BCol } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import InfoCard from "@/components/InfoCard.vue";
import FormModal from "@/components/FormModal.vue";
import FormSelect from "@/components/form-select";
export default {
  components: {
    BCard,
    BSkeleton,
    BButton,
    FeatherIcon,
    InfoCard,
    BRow,
    BCol,
    FormModal,
    FormSelect
  },

  data() {
    return {
      isModalVisible: false,
      formSchema: {
        board_members_count :{
          component: "FormCleave",
          key: "board_members_count",
          attrs: {
            label: "عدد أعضاء مجلس الإدارة",
            rules: "required",
            isNumber: true,
          },

        },
        board_type_id: {
          component: "FormSelect",
          key: "board_type_id",
          attrs: {
            label: "نوع مجلس الإدارة",
            ep: "v2/selects/board-types",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name,
            rules: "required",
          },
        },
        board_election_date: {
          component: "FormMask",
          key: "board_election_date",
          attrs: {
            label: "تاريخ انتخاب / تعيين مجلس الإدارة",
            options: "date",
            rules: "required",
            placeholder: "YYYY-MM-DD",
          },
        },
        term_of_office: {
          component: "FormCleave",
          key: "term_of_office",
          attrs: {
            label: "مدة ولاية مجلس الإدارة",
            rules: "required",
            isNumber: true,
          },
        },
        // public_authority_total_count: {
        //   component: "FormCleave",
        //   key: "public_authority_total_count",
        //   attrs: {
        //     label: "عدد أعضاء الهيئة العامة الكلي",
        //     rules: "required",
        //     isNumber: true,
        //   },
        // },
        // authorised_to_vote_count: {
        //   component: "FormCleave",
        //   key: "authorised_to_vote_count",
        //   attrs: {
        //     label: "عدد أعضاء الهيئة العامة القادرين على التصويت",
        //     rules: "required",
        //     isNumber: true,
        //   },
        // },
        public_authority_last_meeting: {
          component: "FormMask",
          key: "public_authority_last_meeting",
          attrs: {
            label: "تاريخ آخر انعقاد للهيئة العامة",
            options: "date",
            rules: "required",
            placeholder: "YYYY-MM-DD",
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters("AdministrativeStatus/generalInfo", [
      "general_info",
      "loading",
      "editing",
    ]),
    councilType() {
      return this.general_info.members_type ? "الإدارة" : "الأمناء";
    },
  },

  methods: {
    ...mapActions("AdministrativeStatus/generalInfo", ["editGeneralInfo"]),
    openEditModal() {
      var toUpdate = {
        ...this.general_info,
      };
      toUpdate.board_type_id = toUpdate.boardType
        ? toUpdate.boardType.id
        : null;
      delete toUpdate.boardType;
      console.log(toUpdate.members_type);
      if (!toUpdate.members_type) {
        // delete this.formSchema.board_election_date;
        // delete this.formSchema.term_of_office;
        delete this.formSchema.public_authority_total_count;
        delete this.formSchema.authorised_to_vote_count;
        delete this.formSchema.public_authority_last_meeting;
        // delete toUpdate.board_election_date;
        // delete toUpdate.term_of_office;
        delete toUpdate.public_authority_total_count;
        delete toUpdate.authorised_to_vote_count;
        delete toUpdate.public_authority_last_meeting;
        this.formSchema.board_type_id.attrs.label = "نوع مجلس الأمناء";
        this.formSchema.board_members_count.attrs.label = "عدد أعضاء مجلس الأمناء";
        this.formSchema.board_election_date.attrs.label = " تاريخ انتخاب  مجلس الأمناء";
        this.formSchema.term_of_office.attrs.label = "مدة ولاية مجلس الأمناء";
        
        
      }

      this.$refs.editModal.init(toUpdate);
      this.isModalVisible = true;
    },
    async editConfirmed(form) {
      if(form.board_members_count %2 !== 0){
        await this.editGeneralInfo(form);
        this.isModalVisible = false;
      }
    },
  },
  created() {
    this.$store.dispatch("AdministrativeStatus/generalInfo/getGenaralInfo");
  },
};
</script>
<style lang="scss">
.general_info {
  min-height: 50vh;
  h2 {
    color: #5085b3;
  }
  ul {
    li {
      font-size: 16px;
      margin-top: 4px;
      margin-bottom: 4px;
    }
  }
}
</style>
